var map = {
	"./freespin1_multiplier1.png": "3efaf",
	"./freespin1_multiplier2.png": "2dda",
	"./freespin1_multiplier3.png": "6ad0",
	"./freespin1_multiplier5.png": "7ede",
	"./freespin2_multiplier20.png": "3586",
	"./freespin2_multiplier3.png": "d123",
	"./freespin2_multiplier6.png": "4b11",
	"./freespin2_multiplier9.png": "cad0",
	"./freespin3_multiplier12.png": "bcd1",
	"./freespin3_multiplier18.png": "91fc",
	"./freespin3_multiplier40.png": "1e5a",
	"./freespin3_multiplier6.png": "8edd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "27df";